import Image from "@Components/Image";
import config from "@Config/index";
import { CHINA_FOOTER_QR_APP_DOWNLOAD_URL } from "constants/configConstants";
import useIsMiniProgram from "hooks/useIsMiniProgram";
import useTranslationHook from "hooks/useTranslationHook";
import { posthogEventEmitter } from "@Utils/posthog";
import wrapperHOC from "@Utils/wrapperHOC";
import { useEffect } from "react";
import styles from "./ChinaDownloadQRs.module.scss";

type ChinaDownloadQRsProps = {
  /** Reported as `surface` on MP_QR_MODAL_VIEWED. */
  surface: "download_app_modal" | "offer_modal";
  page?: string;
  size?: number;
  appQRSize?: { width: number; height: number };
  miniProgramQRSize?: { width: number; height: number };
  className?: string;
};

/**
 * `.cn` app QR and WeChat Mini Program QR, side by side at equal size.
 * Inside the Mini Program web view only the app QR is shown — the user is already in it.
 * QR images get no resize modifier; resizing breaks scanning.
 */
export const ChinaDownloadQRs = ({
  surface,
  page = "",
  size = 150,
  appQRSize = { width: size, height: size },
  miniProgramQRSize = { width: size, height: size },
  className = "",
}: ChinaDownloadQRsProps) => {
  const { t } = useTranslationHook();
  const isMiniProgram = useIsMiniProgram();

  useEffect(() => {
    if (!isMiniProgram) {
      posthogEventEmitter({ action: "MP_QR_MODAL_VIEWED", surface, page });
    }
  }, []);

  return (
    <div className={`${styles.qrRow} ${className}`}>
      <div className={styles.qrItem}>
        <p className={styles.qrLabel}>{t("header.downloadapp.scan_qr")}</p>
        <Image
          className={styles.qrImg}
          src={CHINA_FOOTER_QR_APP_DOWNLOAD_URL}
          alt={t("header.downloadapp.app_qr_alt")}
          height={appQRSize.height}
          width={appQRSize.width}
          noTransformAnimation
        />
      </div>
      {!isMiniProgram && (
        <div className={styles.qrItem}>
          <p className={styles.qrLabel}>{t("header.downloadapp.scan_miniprogram")}</p>
          <Image
            className={styles.qrImg}
            src={`${config.IMAGE_STATIC_URL}/images/we-chat-bg-removed.png`}
            alt={t("header.downloadapp.miniprogram_qr_alt")}
            height={miniProgramQRSize.height}
            width={miniProgramQRSize.width}
            noTransformAnimation
          />
        </div>
      )}
    </div>
  );
};

export default wrapperHOC(ChinaDownloadQRs, {
  componentName: "ChinaDownloadQRs",
  showForChina: true,
  showForWhiteLable: false,
});
